import React, { useState } from 'react';
import styled from 'styled-components';
import { StyledInput } from './StyledInput';
import { Button } from './Button';
import { GenericModal } from './Modal';
import { Subscription } from '../model/Subscription';
import { isNotEmpty, isValidSsn } from '../utils/validator';
import { useApiMutation } from '../utils/apiHooks';
import { ApiRequest } from '../utils/api';

interface Props {
	subscription: Subscription;
	onClose: () => void;
}

const Container = styled.div`
	text-align: center;
	.title {
		font-size: 1.5em;
	}
`;

const FormContainer = styled.div`
	// border: 1px solid red;
	margin-bottom: 1.818em;
`;

const InputContainer = styled.div`
	width: 17.045em;
	height: 2.386em;
	margin: auto;
	margin-top: 1.818em;
	display: inline-block;
`;

const ErrorMessage = styled.div`
	color: red;
	display: inline-block;
`;

const modalStyles = {
	overlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: '#bcbcbc',
		width: '100%',
		height: '100%',
		padding: '2.102em 0.909em 0em 1.023em'
	},
	content: {
		minHeight: '30.523em',
		width: '26.136em'
	}
};

export const NumsiModal: React.FC<Props> = (props: Props) => {
	const [ownerName, setOwnerName] = useState('');
	const [ssn, setSsn] = useState('');
	const [showErrors, setShowErrors] = useState(false);
	const [sendApiRequest] = useApiMutation<{}, any>((data: any) => ApiRequest.submitNumsi(props.subscription.subscriptionNumber, data));
	const ownerNameValid = isNotEmpty(ownerName);
	const ssnValid = isValidSsn(ssn);
	const submit = () => {
		if (ownerNameValid && ssnValid) {
			const data = {
				mnpPreviousName: ownerName,
				ssn
			};
			sendApiRequest(data, {
				onSuccess: () => window.location.reload()
			});
		} else {
			setShowErrors(true);
		}
	};
	return (
		<GenericModal isOpen={true} onRequestClose={props.onClose} modalStyle={modalStyles}>
			<Container>
				<span className={'title'}>Täydennä liittymän tiedot, jotta Moi voi siirtää vanhan puhelinnumeron uuteen liittymääsi</span>
				<FormContainer>
					<span>Kuka omistaa puhelinnumeron jonka haluat siirtää?</span>
					<InputContainer>
						<StyledInput
							title={'Omistajan nimi'}
							name={'ownerName'}
							backgroundColor={'white'}
							onChange={(e) => {
								setOwnerName(e.target.value);
								setShowErrors(false);
							}}
						/>
						{showErrors && !ownerNameValid && <ErrorMessage>Tarkista kenttä</ErrorMessage>}
					</InputContainer>
					<InputContainer>
						<StyledInput
							title={'Omistajan henkilötunnus'}
							backgroundColor={'white'}
							name={'ssn'}
							onChange={(e) => {
								setSsn(e.target.value);
								setShowErrors(false);
							}}
						/>
						{showErrors && !ssnValid && <ErrorMessage>Tarkista kenttä</ErrorMessage>}
					</InputContainer>
				</FormContainer>
				<Button onClick={submit}>Lähetä</Button>
				<Button onClick={props.onClose}>Takaisin</Button>
			</Container>
		</GenericModal>
	);
};
